import { Table } from '@dixa/lib-shared-habla';
import {
  type Column,
  type Table as TanstackTable,
} from '@tanstack/react-table';
import type { SearchConversationEnriched } from 'lib-search-types';

import type { ConversationsTableFeatures } from '../../../conversationsTable.columns';
import {
  getConversationsTableColumnId,
  getIsConversationsTableScrollable,
} from '../../../conversationsTable.utils';
import { ConversationsTableFillerCell } from '../../fillerCell/conversationsTableFillerCell';

export type ConversationsTableConversationPlaceholderRowsProps = {
  /** The table whose columns get a placeholder cell. */
  table: TanstackTable<ConversationsTableFeatures, SearchConversationEnriched>;
};

export const ConversationsTableConversationPlaceholderRows = ({
  table,
}: ConversationsTableConversationPlaceholderRowsProps): JSX.Element => {
  const height =
    table.options.meta?.layout?.density === 'compact' ? '41px' : '65px';

  const renderCell = (
    column: Column<ConversationsTableFeatures, SearchConversationEnriched>,
  ) => (
    <Table.Td
      key={column.id}
      height={height}
      columnId={getConversationsTableColumnId(column)}
    >
      {column.columnDef.meta?.placeholder?.cell}
    </Table.Td>
  );

  return (
    <>
      {Array.from({ length: 30 }).map((_, index) => (
        <Table.Tr key={index}>
          {table.getStartVisibleLeafColumns().map(renderCell)}
          {table.getCenterVisibleLeafColumns().map(renderCell)}
          {getIsConversationsTableScrollable(table) && (
            <ConversationsTableFillerCell />
          )}
          {table.getEndVisibleLeafColumns().map(renderCell)}
        </Table.Tr>
      ))}
    </>
  );
};
